import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { NgIf } from "@angular/common";
import { Attribute, ChangeDetectionStrategy, Component, Input, Optional } from "@angular/core";
import { IconModule } from "src/app/shared/ui/icon/icon.module";
import { SpinnerComponent } from "../spinner/spinner.component";

export type ButtonSize = "small" | "large";
export type ButtonType = "button" | "submit" | "reset";

@Component({
  selector: "tpm-button",
  templateUrl: "button.component.html",
  styleUrls: ["button.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, IconModule, SpinnerComponent],
  host: {
    "[attr.disabled]": "disabled || loading",
    "[attr.loading]": "loading",
    "[class.full-width]": "fullWidth"
  }
})
export class ButtonComponent {
  @Input() icon: string | undefined;
  @Input() iconRight: string | undefined;
  @Input() size: ButtonSize = "small";

  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;

  constructor(
    @Attribute("type") @Optional() readonly type: ButtonType,
    @Attribute("form") @Optional() readonly form: string,
    @Attribute("full-width") @Optional() readonly fullWidth: boolean,
    @Attribute("button-outline") @Optional() readonly buttonOutline: boolean,
    @Attribute("button-filled") @Optional() readonly buttonFilled: boolean,
    @Attribute("button-tonal") @Optional() readonly buttonTonal: boolean,
    @Attribute("button-rounded") @Optional() readonly buttonRounded: boolean,
    @Attribute("button-link") @Optional() readonly buttonLink: boolean
  ) {
    this.fullWidth = coerceBooleanProperty(this.fullWidth);
    this.type = this.type || "button";
    this.buttonOutline = coerceBooleanProperty(this.buttonOutline);
    this.buttonFilled = coerceBooleanProperty(this.buttonFilled);
    this.buttonTonal = coerceBooleanProperty(this.buttonTonal);
    this.buttonRounded = coerceBooleanProperty(this.buttonRounded);
    this.buttonLink = coerceBooleanProperty(this.buttonLink);
  }
}
